"use client"

import * as React from "react"
import { ThemeProvider as NextThemesProvider } from "next-themes"

// Get props type directly from NextThemesProvider
type NextThemesProviderProps = React.ComponentProps<typeof NextThemesProvider>;

// HOTFIX (2026-07-06, site-wide "Application error" on prod): Next 15's
// webpack chunking wraps next-themes' module constants in a chunk-group guard
// (`9121==r.j ? ["light","dark"] : null`) and the commons-chunk copy resolves
// them to NULL — the library's `themes` default becomes null ("c is not
// iterable" in its useMemo) and its colorSchemes constant null-crashes when
// enableColorScheme is on. Only minified production builds are affected (dev
// has no guards), which is why local dev and every build gate stayed green.
// Passing both values explicitly means the broken defaults are never
// consulted. Do NOT remove these fallbacks until the bundler defect is gone
// (verify by grepping the built commons chunk for `==r.j?["light","dark"]:null`).
export function ThemeProvider({
  children,
  themes,
  enableColorScheme,
  ...props
}: NextThemesProviderProps) {
  return (
    <NextThemesProvider
      themes={themes ?? ["light", "dark"]}
      enableColorScheme={enableColorScheme ?? false}
      {...props}
    >
      {children}
    </NextThemesProvider>
  )
}